export const DOMAIN_LOCALHOST = 'localhost';
export const DOMAIN_PUSHWOOSH = 'sso.pushwoosh.com';
export const DOMAIN_OMO = 'sso.omo-tech';
export const DOMAIN_WAVESEND = 'sso.wavesend';
export const DOMAIN_PUSHWOOSH_US = 'sso.pushwoosh.us';

// Brand-wide match: covers both sso.wavesend.ru and sso.svc.wavesend.ru.
export const DOMAIN_WAVESEND_RU = 'wavesend.ru';

// Dev environments: pushwoosh-installer stands (sso.pwi.pushwoosh.com etc).
// Production domains above are not listed here, so production is unaffected.
export const DOMAIN_DEV_MARKERS = [
  '.pwi.pushwoosh.com',
];
